export const Languages = {
	en: 'en',
	no: 'no',
	de: "de",
	ru: "ru",
	pl: "pl",
	fr: "fr",
	es: "es",
	it: "it",
	da: "da",
	nl: "nl",
  ro: "ro",
  pt: "pt"
};

export const DefaultLng = Languages.en;